module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/icon_pin-b1a96623d89ae3278272b4c6c9155e4b.svg";